const content = (
  <div>
    <p>
      Chez Natelco, nous croyons que chaque organisation est unique. C’est
      pourquoi nous proposons des formations spécifiquement conçues selon vos
      besoins.
      <br />À la suite d’un ou deux rendez-vous de cadrage avec le client, nous
      analysons les attentes, les enjeux, et les objectifs visés. À partir de
      cette phase d’écoute, nous élaborons un programme personnalisé, intégrant
      des exercices adaptés, des mises en situation, et des outils concrets
      immédiatement transférables sur le terrain.
    </p>
    <h2>Nos thématiques phares incluent :</h2>
    <p>
      À partir de cette phase d’écoute, nous élaborons un programme
      personnalisé, intégrant des exercices adaptés, des mises en situation, et
      des outils concrets immédiatement transférables sur le terrain.
    </p>
    <h2>Nos thématiques phares incluent :</h2>
    <ul>
      <li>Le renforcement des compétences clés individuelles et collectives</li>
      <li>L’optimisation de la posture managériale</li>
      <li>La mobilisation de la dynamique de groupe</li>
      <li>La gestion des personnalités complexes et de la motivation</li>
      <li>
        Le management des situations de crise et l'engagement et la
        participation de chacun
      </li>
      <li>
        Le développement de la communication et de la posture professionnelle
      </li>
      <li>L’organisation et la gestion du temps</li>
      <li>L’exploitation de l’intelligence collective et émotionnelle</li>
      <li>L’affirmation de l’assertivité et du leadership</li>
      <li>La crédibilité et la légitimité dans la prise de poste</li>
      <li>L'accompagnement dans les transitions de carrière</li>
      <li>La valorisation et le développement des compétences</li>
      <li>La progression dans les parcours d’évolution professionnelle</li>
    </ul>
    <p>
      Chaque formation est conçue pour favoriser des apprentissages concrets,
      durables et directement transposables au quotidien.
      <br />
      Nos formations sont disponibles en présentiel distanciel et peuvent être
      dispensées en individuel ou en collectif, selon vos préférences.
      <br />
      👉 Contactez-nous pour concevoir ensemble votre prochain parcours de
      montée en compétences.
      <br />
      Voici quelques exemples de formation donnes en 2025 : Formation
      Managériale
    </p>
    <ul>
      <li>Petite Structure Tech</li>
    </ul>
  </div>
);

export default content;
